import React, { useRef } from "react";
import { useBannerParticles } from "./useBannerParticles";
import aevoArtwork from "./assets/crystal-ae-ring.jpg";
import {
  Banner,
  BannerArtwork,
  BannerHash,
  BannerParticles,
  BannerLightLeak,
  BannerTitle,
} from "./HandoffBanner.style";

const hashRows = [
  "8C69D4F0A13E2B",
  "0A71C9E42D85F3",
  "F291B6D0E84A7C",
  "3E0C8A5D9F714B",
  "7B42F1C6E03A9D",
];

export default function HandoffBanner() {
  const canvas = useRef<HTMLCanvasElement>(null);
  const artwork = useRef<HTMLImageElement>(null);
  useBannerParticles(canvas, artwork);
  return (
    <Banner aria-label="Affiliate Dashboard">
      <BannerArtwork
        ref={artwork}
        src={aevoArtwork}
        alt=""
        aria-hidden="true"
      />
      <BannerParticles ref={canvas} aria-hidden="true" />
      <BannerLightLeak aria-hidden="true" />
      <BannerTitle>Affiliate Dashboard</BannerTitle>
      <BannerHash aria-hidden="true">
        {hashRows.map((row) => (
          <span key={row}>{row}</span>
        ))}
      </BannerHash>
    </Banner>
  );
}
